import { useState } from "react";
import { HomeDashboardRepository, type HomeDashboardState } from "../../application/home-dashboard";

export function useWater({ selectedDate, dashboard, dashboardRepository }: { selectedDate: string; dashboard: HomeDashboardState; dashboardRepository: Pick<HomeDashboardRepository, "addWaterGlass" | "setWater"> }) {
  const [waterOpen, setWaterOpen] = useState(false);
  const [glassMilliliters, setGlassMilliliters] = useState(() => {
    const stored = typeof localStorage === "undefined" ? NaN : Number(localStorage.getItem("yumnote.glassMilliliters"));
    return Number.isFinite(stored) && stored >= 50 && stored <= 1000 ? stored : 250;
  });
  const [waterDraftMilliliters, setWaterDraftMilliliters] = useState(0);
  const [waterDraftGlass, setWaterDraftGlass] = useState(250);
  const [waterStatus, setWaterStatus] = useState<"idle" | "saving" | "error">("idle");
  const addWater = async () => {
    if (waterStatus === "saving") return;
    setWaterStatus("saving");
    try {
      await dashboardRepository.addWaterGlass(selectedDate, glassMilliliters);
      setWaterStatus("idle");
    } catch {
      setWaterStatus("error");
    }
  };

  const openWater = () => {
    setWaterDraftMilliliters(dashboard.water.milliliters);
    setWaterDraftGlass(glassMilliliters);
    setWaterOpen(true);
  };

  const saveWater = async () => {
    setWaterStatus("saving");
    try {
      await dashboardRepository.setWater(selectedDate, waterDraftMilliliters);
      setGlassMilliliters(waterDraftGlass);
      localStorage.setItem("yumnote.glassMilliliters", String(waterDraftGlass));
      setWaterOpen(false);
      setWaterStatus("idle");
    } catch {
      setWaterStatus("error");
    }
  };

  return { waterOpen, setWaterOpen, glassMilliliters, waterDraftMilliliters, setWaterDraftMilliliters, waterDraftGlass, setWaterDraftGlass, waterStatus, addWater, openWater, saveWater };
}
